import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const AdsPrincipalListRBAC = {
  pageID: '5d36e8d8d006b0d0042a4b699d07e951',
  elementID: {
    ViewOnly: '590657f2fd5572979852b1f1e6792367',
  },
} as const

export const useAdsPrincipalListRBAC = createUseRBAC(AdsPrincipalListRBAC.elementID)

export type UseAdsPrincipalListRBACType = ReturnType<typeof useAdsPrincipalListRBAC>
